// Expiry actions (for tickets, contracts, etc.)
import {
  shouldShowExpiryToast,
  markExpiryToastDismissed
} from "../utils/ticketHelpers";

export const SET_EXPIRING_TICKETS = "SET_EXPIRING_TICKETS";
export const DISMISS_TICKET_TOAST = "DISMISS_TICKET_TOAST";
export const SHOW_TICKET_MODAL = "SHOW_TICKET_MODAL";
export const HIDE_TICKET_MODAL = "HIDE_TICKET_MODAL";

/**
 * Set expiring items in Redux store.
 * The toast only pops when this exact set of tickets (same day, same
 * urgency levels) has not already been dismissed by the user.
 * @param {Array} tickets - Array of expiring ticket/contract objects
 */
export const setExpiringTickets = (tickets) => {
  const list = Array.isArray(tickets) ? tickets : [];
  return {
    type: SET_EXPIRING_TICKETS,
    payload: {
      tickets: list,
      showToast: shouldShowExpiryToast(list)
    }
  };
};

/**
 * Dismiss the expiration toast and remember the dismissal so the
 * same reminder is not repeated on every page load.
 */
export const dismissTicketToast = () => (dispatch, getState) => {
  const { expiry } = getState();
  markExpiryToastDismissed(expiry ? expiry.expiringTickets : []);
  dispatch({ type: DISMISS_TICKET_TOAST });
};

/**
 * Show the expiration modal
 */
export const showTicketModal = () => ({
  type: SHOW_TICKET_MODAL
});

/**
 * Hide the expiration modal
 */
export const hideTicketModal = () => ({
  type: HIDE_TICKET_MODAL
});
